<template>
    <div class="myClassList">
        <div class="search_container searchArea">
            <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">

                <el-form-item label="查找">
                    <el-input v-model="searchForm.searchText" placeholder="名称或入学年"  @keyup.enter.native='handleSearch'></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" size ="mini" icon="search" @click='handleSearch'>查询</el-button>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" size ="mini" icon="search" @click='openMyClass(null)'>我是班主任</el-button>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" size ="mini" icon="search" @click='openMyClassCourse(null)'>设定我的行政班</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table_container">
            <el-table v-loading="loading" :data="tableData" style="width: 100%" align='center'>

                <el-table-column prop="hard_name" label="班级名称"  min-width="150" show-overflow-tooltip align='center' ></el-table-column>
                <el-table-column prop="year" label="入学年" width="70" align='center' ></el-table-column>
                <!-- <el-table-column prop="role" label="我是" align='center' width="90" :formatter="formatterRole"></el-table-column> -->
                <el-table-column prop="course_name" label="课程名称" show-overflow-tooltip align='center' :formatter="formatterCourse"></el-table-column>
                <!-- <el-table-column prop="exams_count" label="试卷数" align='center' ></el-table-column> -->
                <el-table-column prop="operation" align='center' label="操作" min-width="200">
                    <template slot-scope='scope'>
                        <!-- <el-button type="primary" icon='edit' size="mini" @click='onOutPut(scope.row)'>导出成绩</el-button> -->
                        <!-- <el-button type="primary"> 编辑</el-button> -->
                        <el-button type="danger" icon='edit' size="mini" @click='onDeleteMyClass(scope.row)'>删除</el-button>
                        
                    </template>
                </el-table-column>
            </el-table>
            <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
        </div>
        <myClassDialog ref="myClassDialog" :myClass="selMyClass" @ok="handleSearch"></myClassDialog>
        <myClassCourseDialog ref="myClassCourseDialog" :myClassCourse="selMyClass" @ok="handleSearch"></myClassCourseDialog>
        <myExamDialog ref="myExamDialog" :myExam="selMyClass"></myExamDialog>
    </div>
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import XEUtils from 'xe-utils'
    import myClassDialog from "./myClassDialog";
    import myExamDialog from "./myExamDialog";
    import myClassCourseDialog from "@/views/sclTeacher/myClass/myClassCourseDialog";
    import * as simpleApi from "request/simple";
    import Pagination from "@/components/pagination";

    export default {
        name: 'myClassList',
        data(){
            return {
                tableData: [], tableHeight:0,
                loading:true, isShow:false,
                schoolList: [], professionList: [],
                selMyClass: null, selMyClassDtl: null,
                searchForm:{ pageNo: 1, pageSize: 50, totalCount: 0, searchText: null, schoolId: null, professionId: null},
            }
        },
        components:{
            myClassDialog, myClassCourseDialog, myExamDialog, Pagination
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            })
        },
      	mounted() {
            this.loadMyClassList();
	   },
        methods: {
            handleSearch(){
                this.searchForm.pageNo = 1;
                this.loadMyClassList();
            },
            loadMyClassList(){
                this.loading = true;

                let search = { searchText: mUtils.searchText(this.searchForm.searchText), teacherId: this.userInfo.id};
                let param = { controllerName: 'teacherMyClass', methodName: '/myClassList', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.tableData = data.result;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    console.log("error")
                });
            },

            // 上下分页
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadMyClassList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadMyClassList()
            },
            formatterRole(row, column, cellValue, index){
                if(cellValue == "BZ") return "班主任";
                if(cellValue == "RK") return "授课老师";
                return cellValue;
            },
            formatterCourse(row, column, cellValue, index){
                if(cellValue != null && row.course_no != null) return cellValue+'('+row.course_no+ ')';
                return '无';
            },
            onOutPut(row){
                this.selMyClass = row;
                this.$refs.myExamDialog.showDialog();
            },
            onDeleteMyClass(row){
                let id = row.id
                let that = this;
                this.$confirm('此操作将删除数据, 是否继续?', '提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(() => {
                    let param = { controllerName: 'teacherMyClass', methodName: '/delete', param: { id: id }};
                    if(row.role == "BZ"){ param = { controllerName: 'sclHardClass', methodName: '/updateClassTeacher', param: { id: id }}; }
                    simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        if (code == 0) {
                            that.$message({ type: 'success', message: '删除成功!'});
                            that.handleSearch();
                        }else{
                            that.$message({ type: 'error', message: '删除失败！'});
                            return ;
                        }
                    });
                }).catch(() => {

                });
            },

            openMyClass(row){
                if(row != null){
                    this.selMyClass = row;
                }else{
                    this.selMyClass = { id: null,  time: (new Date()).getMilliseconds()};
                }
                this.$refs.myClassDialog.showDialog();
            },
            openMyClassCourse(row){
                if(row != null){
                    this.selMyClass = row;
                }else{
                    this.selMyClass = { id: null,  time: (new Date()).getMilliseconds()};
                }
                this.$refs.myClassCourseDialog.showDialog();
            },

        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .search_container{

    }
    .btnRight{
        float: right;
        margin-right: 0px !important;
    }
    .searchArea{
        background:rgba(255,255,255,1);
        border-radius:2px;
        padding: 18px 18px 0;
    }
    .table_container{
        padding: 10px;
        background: #fff;
        border-radius: 2px;
    }
    .el-dialog--small{
       width: 600px !important;
    }
    .pagination{
        text-align: left;
        margin-top: 10px;
    }

</style>


